module.exports = __webpack_public_path__ + "static/media/digitalParenting.68fefafa.png";